import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

// Component Imports
import DownloadManager from './components/common/DownloadManager';
import HomePage from './pages/HomePage';
import NotFound from './pages/NotFound';
import BrowseSchools from './pages/BrowseSchools';
import SearchPage from './pages/SearchPage';
import TeacherPortal from './pages/TeacherPortal';
import AdminPortal from './pages/AdminPortal';
import ProtectedRoute from './components/ProtectedRoute';

// School & Material Navigation Imports
import SchoolPage from './pages/SchoolPage';
import YearSelection from './pages/YearSelection';
import CourseList from './pages/CourseList';
import CourseMaterials from './pages/CourseMaterials';
import MaterialDetail from './pages/MaterialDetail';
import Dashboard from './pages/Dashboard';
import CourseTeachers from './pages/CourseTeachers'; // ✅ IMPORT THIS
import FeedbackPage from './pages/FeedbackPage';

import SchoolAdminPortal from './pages/SchoolAdminPortal';

import './index.css';

function App() {
  return (
    <Router>
      <div className="App min-h-screen bg-gray-50">
        <Toaster position="top-right" />
        
        <Routes>
          {/* Main Pages */}
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/browse" element={<BrowseSchools />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/feedback" element={<FeedbackPage />} />
         
          {/* Protected Routes - FIXED: Use consistent paths */}
          <Route path="/teachers" element={
            <ProtectedRoute allowedRoles={['teacher', 'admin']}>
              <TeacherPortal />
            </ProtectedRoute>
          } />
          
          <Route path="/school-admin/*" element={
            <ProtectedRoute allowedRoles={['school_admin']}>
              <SchoolAdminPortal />
            </ProtectedRoute>
          } />

          <Route path="/admin" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminPortal />
            </ProtectedRoute>
          } />

          <Route path="/super-admin" element={<Navigate to="/admin" replace />} />
          
          {/* Remove duplicate /admins route */}
          
          {/* --- School Navigation Routes --- */}
          
          {/* 1. School Landing Page */}
          <Route path="/school/:id" element={<SchoolPage />} />
          
          {/* 2. Department Page (Years) */}
          <Route path="/school/:schoolId/department/:departmentId" element={<YearSelection />} />
          
          {/* 3. Year Page (Courses) */}
          <Route path="/school/:schoolId/department/:departmentId/year/:year" element={<CourseList />} />
          
          {/* 4. NEW: Teacher Selection Page (After clicking a Course) */}
          <Route path="/school/:schoolId/department/:departmentId/year/:year/course/:courseId" element={<CourseTeachers />} />

          {/* 5. UPDATED: Course Materials Page (After clicking a Teacher) */}
          <Route path="/school/:schoolId/department/:departmentId/year/:year/course/:courseId/teacher/:teacherId" element={<CourseMaterials />} />
          
          {/* 6. Individual Material Detail */}
          <Route path="/material/:materialId" element={<MaterialDetail />} />       
          
          {/* Error Pages */}
          <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        
        <DownloadManager />
      </div>
    </Router>
  );
}

export default App;